import { render, staticRenderFns } from "./userCenter.vue?vue&type=template&id=590e47e6&scoped=true"
import script from "./userCenter.vue?vue&type=script&lang=js"
export * from "./userCenter.vue?vue&type=script&lang=js"
import style0 from "./userCenter.vue?vue&type=style&index=0&id=590e47e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590e47e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('590e47e6')) {
      api.createRecord('590e47e6', component.options)
    } else {
      api.reload('590e47e6', component.options)
    }
    module.hot.accept("./userCenter.vue?vue&type=template&id=590e47e6&scoped=true", function () {
      api.rerender('590e47e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemAdministrator/creatApp/components/userCenter.vue"
export default component.exports